// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db } from '@/shared/firebase/firebase-init';
const SIZE = 10;

export default {
  fetch(lastmodified) {
    return new Promise((resolve) => {
      console.log(lastmodified);
      
      db.ref("log")
        .child("logs")
        .child("players")
        .orderByChild("modified")
        .endAt(lastmodified-1)
        .limitToLast(SIZE)
        .once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        
        const result =  {
          data: list.reverse(),
          last: list.length < SIZE
        }

        resolve(result)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/player/player-history/player-history-full/player-history-full-service.js